<template>
  <md-card>
      <md-card-content class="challenge-shopping-info md-layout">
        <div  class="md-layout-item md-size-auto">
          <md-card-media class="md-ratio-4-3">
            <img v-if="challenge.titleImage" :src="challenge.titleImage" />
          </md-card-media>
          <md-button v-if="displayBackButton" @click="goToRoute(`/Challenges/${challenge._id}`)">{{$t('challenge.backToChallenge')}}</md-button>
        </div>
        <div class="general-info md-layout-item md-size-70 md-xsmall-size-100">
          <div class="h4" v-html="challenge.title"></div>
          <div
              v-html="challenge.feedDescription"
          ></div>
          <span>
          {{ formatFromToDate(challenge.start, challenge.end) }}
        </span>
        </div>
      </md-card-content>
    </md-card>
</template>

<script>
import datetime from "@/utils/datetime";

export default {
  props: {
    challenge: {
      type: Object,
      required: true
    },
    displayBackButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...datetime
  }
}
</script>

<style lang="scss">
.challenge-shopping-info {
  display: flex;
  .md-card-media {
    min-width: 150px;
    flex: 1 1 auto;
  }
  .general-info {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>